import styled from 'styled-components';
import { IonContent, IonHeader } from '@ionic/react';

export const IonHeaderWrapper = styled(IonHeader)`
  .searchbar-input.sc-ion-searchbar-ios {
    display: flex;
    align-items: center;

    input {
      padding: 5px;
    }
  }

  .date-time-button {
    flex: 1 0 auto;

    &::part(native) {
      flex: 1 0 auto;
      background-color: transparent;
    }
  }
`;

export const IonContentWrapper = styled(IonContent)``;
